import { QueryOptionsWithoutKeyAndFn } from '@/lib/tanstack-utils.types'
import { useQuery } from '@tanstack/react-query'
import { GetAllRulesParams, paymentApprovalApi } from '../api'
import { paymentApprovalKeys } from '../keys'
import { PaginatedApprovalRulesResponse } from '../schema'

export function useGetAllRules(
  params: GetAllRulesParams,
  options: QueryOptionsWithoutKeyAndFn<PaginatedApprovalRulesResponse>
) {
  return useQuery({
    queryFn: () => paymentApprovalApi.getAllRules(params),
    queryKey: paymentApprovalKeys.allRules(params),
    ...options,
  })
}
